<template>
  <div class="app-main-inner">
    <div class="app-main-inner-row">
      <div class="triggers">
        <el-button v-if="!showIfRisk" no="new" type="primary" @click="showEditDialog(true)">{{ $t('common.btn.new') }}</el-button>
        <el-button no="edit" type="primary" @click="showEditDialog(false)">{{ $t('common.btn.edit') }}</el-button>
        <el-button v-if="!showIfRisk" no="delete" type="danger" @click="remove">{{ $t('common.btn.delete') }}</el-button>
      </div>
    </div>
    <div class="app-main-inner-row row-grid">
      <cargo-ag-grid
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
        style="width: 100%;"
        @gridReady="onGridReady"
      />
    </div>
    <!-- 编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="editDialog.title"
      width="420px"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="120px" label-position="left">
          <el-form-item :label="$t('Message.CurrencyExchangeRateIsNotMaintained1')">
            <el-select v-model="editDialog.form.currency" no="currency" filterable style="width: 100%;">
              <el-option
                v-for="item in currencyList"
                :key="item.uuid"
                :value="item.code"
                :label="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('Partners.bankName')">
            <el-input v-model="editDialog.form.bank" no="bank" :disabled="oujianEditLimit" />
          </el-form-item>
          <el-form-item :label="$t('Partners.bankEnglishName')">
            <el-input v-model="editDialog.form.bankEnglishName" no="bankEnglishName" />
          </el-form-item>
          <el-form-item :label="$t('Partners.bankAccount')">
            <el-input v-model="editDialog.form.bankAccount" no="bankAccount" :disabled="oujianEditLimit" />
          </el-form-item>
          <el-form-item :label="$t('Partners.bankAddress')">
            <el-input v-model="editDialog.form.bankAddr" no="bankAddr" />
          </el-form-item>
          <el-form-item :label="$t('Partners.bankEnglishAddress')">
            <el-input v-model="editDialog.form.bankEnglishAddr" no="bankEnglishAddr" />
          </el-form-item>
          <el-form-item :label="$t('Partners.paymentLine')">
            <el-input v-model="editDialog.form.paymentLine" no="paymentLine" />
          </el-form-item>
          <el-form-item :label="$t('Partners.swiftCode')">
            <el-input v-model="editDialog.form.swiftCode" no="swiftCode" />
          </el-form-item>
          <el-form-item :label="$t('Partners.isDefault')">
            <el-radio-group v-model="editDialog.form.defaultBank" no="defaultBank" @change="onDefaultChange">
              <el-radio no="yes" :label="true">{{ $t('Message.Yes') }}</el-radio>
              <el-radio no="no" :label="false">{{ $t('Message.No') }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button no="save" type="primary" @click="saveTemporary">{{ $t('common.btn.save') }}</el-button>
        <el-button no="cancel" @click="editDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { AutoIncrementNum } from '@/utils/commonUtil'
import { getNoPaginationCurrencyList } from '@/api/basicData/currency'

export default {
  name: 'TitleBankForm',
  components: { },
  props: {
    title: {
      type: Object,
      required: true
    },
    showIfRisk: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currencyList: [],
      filter: {
        titleUuidList: ''
      },
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        context: {
          componentParent: this
        }
      },
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      columnDefs: [
        {
          headerName: this.$t('Message.CurrencyExchangeRateIsNotMaintained1'),
          field: 'currency',
          width: 100
        }, {
          headerName: this.$t('Partners.bankName'),
          field: 'bank',
          width: 200
        }, {
          headerName: this.$t('Partners.bankAccount'),
          field: 'bankAccount',
          width: 200
        }, {
          headerName: this.$t('Partners.swiftCode'),
          field: 'swiftCode',
          width: 200
        }, {
          headerName: this.$t('Partners.paymentLine'),
          field: 'paymentLine',
          width: 200
        }, {
          headerName: this.$t('Partners.isDefault'),
          field: 'defaultBank',
          width: 110,
          cellRenderer: params => {
            return params.value ? '√' : ''
          }
        }, {
          headerName: this.$t('Partners.bankEnglishName'),
          field: 'bankEnglishName',
          width: 200
        }, {
          headerName: this.$t('Partners.bankAddress'),
          field: 'bankAddr',
          width: 200
        }, {
          headerName: this.$t('Partners.bankEnglishAddress'),
          field: 'bankEnglishAddr',
          width: 200
        }
      ],
      rowData: [],
      deletedBankKeys: [],
      gridApi: null,
      editDialog: {
        visible: false,
        title: '',
        form: {
          uuid: '',
          currency: '',
          bank: '',
          bankAccount: '',
          swiftCode: '',
          paymentLine: '',
          defaultBank: '',
          titleUuid: '',
          bankEnglishName: '',
          bankAddr: '',
          bankEnglishAddr: ''
        }
      },
      autoIncrementNum: new AutoIncrementNum()
    }
  },
  computed: {
    // CARGO-45565 客商数据CargoWare读取欧坚数据库 判断是否是编辑状态，如果是编辑状态，就隐藏
    oujianEditLimit() {
      return this.editDialog.title === this.$t('common.btn.edit') && this.showIfRisk
    }
  },
  watch: {
    title(newVal) {
      this.filter.titleUuidList = newVal.uuid
      this.rowData = newVal.bankList
      this.deletedBankKeys = newVal.deletedBankKeys = newVal.deletedBankKeys || []
    }
  },
  created() {
    getNoPaginationCurrencyList().then(res => {
      this.currencyList = res.data
    })
    this.filter.titleUuidList = this.title.uuid || ''
    this.rowData = this.title.bankList || []
    this.deletedBankKeys = this.title.deletedBankKeys || []
  },
  methods: {
    onGridReady(params) {
      const self = this
      self.gridApi = params.api
    },
    showEditDialog(isNew) {
      if (isNew) {
        this.editDialog.form = {
          uuid: '',
          currency: '',
          bank: '',
          bankAccount: '',
          swiftCode: '',
          paymentLine: '',
          defaultBank: true,
          titleUuid: this.filter.titleUuidList,
          seq: this.autoIncrementNum.getNextNum()
        }
        this.editDialog.title = this.$t('common.btn.new')
      } else {
        const cell = this.gridApi.getFocusedCell()
        const row = cell ? this.rowData[cell.rowIndex] : null
        if (!row) {
          this.$message.warning(this.$t('common.tips.hasOneAtleast'))
          return
        }
        this.editDialog.form = { ...row }
        this.editDialog.title = this.$t('common.btn.edit')
      }
      this.editDialog.visible = true
    },
    onDefaultChange() {
      const form = this.editDialog.form
      if (form.defaultBank) {
        const existItem = this.rowData.find(p => p.defaultBank && p.uuid !== form.uuid)
        if (existItem) {
          this.$message.warning(this.$t('Partners.alreadyDefaultBankInformation'))
        }
      }
    },
    // 临时保存
    saveTemporary() {
      const form = this.editDialog.form
      // 若该数据被设为默认银行，且列表已有默认银行，将已有默认银行数据改为非默认
      if (form.defaultBank) {
        const existItem = this.rowData.find(p => p.defaultBank && p !== form)
        if (existItem) {
          existItem.defaultBank = false
        }
      }
      const oldRow = this.rowData.find(p => p.seq === form.seq)
      if (oldRow) {
        Object.assign(oldRow, form)
        this.gridApi.refreshCells({ force: true })
      } else {
        this.rowData.push(form)
      }
      this.editDialog.visible = false
    },
    async remove() {
      const cell = this.gridApi.getFocusedCell()
      const row = cell ? this.rowData[cell.rowIndex] : null
      if (!row) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      this.$confirm(this.$t('common.tips.confirmDelete'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        // 若删除的是默认，将剩余数据中的一条改为默认
        const existItem = this.rowData.find(p => p.seq !== row.seq)
        if (existItem) {
          existItem.defaultBank = true
        }
        const index = this.rowData.findIndex(p => p.seq === row.seq)
        this.rowData.splice(index, 1)
        if (row.uuid) {
          this.deletedBankKeys.push(row.uuid)
        }
      })
    }
  }
}
</script>

<style>
</style>
